import { render, staticRenderFns } from "./content-loading.vue?vue&type=template&id=002cb3d2"
import script from "./content-loading.vue?vue&type=script&lang=js"
export * from "./content-loading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports